import React, { useEffect, useState } from 'react';
import './custom-table.css';

type Column = {
  id: string;
  label: string;
  index?: string;
};

type RowData = {
  [key: string]: string | number;
};

interface TableProps {
  columns: Column[];
  data: RowData[];
  onRowSelect?: (data: any) => void;
}

const CustomTable: React.FC<TableProps> = ({ columns, data, onRowSelect }) => {
  const [sortedData, setSortedData] = useState<RowData[]>(data);
  const [selectedRows, setSelectedRows] = useState<number>();

  // Handle sorting
  const handleSort = (columnId: string) => {
    // const sorted = [...sortedData].sort((a, b) => {
    //   if (a[columnId] < b[columnId]) return -1;
    //   if (a[columnId] > b[columnId]) return 1;
    //   return 0;
    // });

    // setSortedData(sorted);
  };


  useEffect(()=>{
    setSortedData(data)
  }, [data])

  
  // Handle row selection
  const handleRowSelect = (index: any, data:any) => {
    setSelectedRows(index);

    if (onRowSelect) {
      onRowSelect(data);
    }
  };

  return (
    <table className='base-Table'>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.id}>
              <button onClick={() => handleSort(column.id)}>
                {column.label}
              </button>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sortedData.map((row, rowIndex) => (
          <tr
            key={rowIndex}
            onClick={() => handleRowSelect(rowIndex, row)}
            className={selectedRows===rowIndex ? 'selected' : ''}
          >
            {columns.map((column) => (
              <td key={column.id}>{row[column.id]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CustomTable;
